module.exports = __webpack_public_path__ + "img/checked_circle.c79984d7.svg";